
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 67.312 94.95"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#F26522","d":"M67.312 33.656c0 18.588-33.656 61.295-33.656 61.295S0 52.244 0 33.656 15.068 0 33.656 0s33.656 15.068 33.656 33.656z"}}),_c('path',{attrs:{"fill":"#6E559E","d":"M49.419 40.023h-11.56v11.745h-8.407V40.023h-11.56v-7.974h11.56V20.242h8.407v11.807h11.56v7.974z"}})])
          )
        }
      }
    